import { useTranslation } from "react-i18next"
import { useIsHardNo } from "../util/useDomain";
import styled from "styled-components";



export default function About() {
  const { t } = useTranslation();
  const { isHardNo } = useIsHardNo();

  const email = isHardNo
    ? "contact@hardno.eu"
    : "contact@boycott-flyer.eu";

  return (
    <div className="generic-page">
      <div className="narrow-content">
        <h1>{t('about-us.nav')}</h1>
        {t('about.text').split('\n\n').map((p) => <p>{p}</p>)}
        <p>{t('about.support-shop.text')}</p>
        <LandscapeRow>
            <a href="https://hardno.tpopsite.com" target="_blank">
              <img src="store_illustration.png" alt="Hardno store" />
            </a>
        </LandscapeRow>

        <p>{t('contact-me.label')}: <a href={`mailto:${email}`}>{email}</a></p>
      </div>
    </div>
  )
}

const LandscapeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: left;
  gap: 20px;
  margin: 1.0rem 0 2.0rem 0;

  a {
    width: 226px;
    margin: 0 auto 0 0;
    height: 160px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  img {
    width: 100%;
    border-radius: 10px;
  }
`
